import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IApiCompany, IApiCompanyFilter, IApiCompanyFilterType } from 'src/app/shared/modules/graphql/types/types';
import { CompanyService } from 'src/app/shared/services';
import { unwrapConnection } from 'src/app/shared/rxjs.pipes';

@Component({
    selector: 'app-bookkeeping-company-filter',
    templateUrl: './bookkeeping-company-filter.component.html',
    styleUrls: ['./bookkeeping-company-filter.component.scss']
})
export class BookkeepingCompanyFilterComponent {

    public readonly companyKey = 'customer.contacts.default.companyName';

    public operators = [
        { text: 'In', value: '$in' },
        { text: 'Not In', value: '$notIn' }
    ];

    @Input() public operator: '$in' | '$notIn' = '$in';
    @Output() public operatorChange = new EventEmitter<'$in' | '$notIn'>();

    /** Tracks currently selected company IDs (for binding back to the multiselect) */
    @Input() public selectedCompanyIds: string[] = [];
    @Output() public selectedCompanyIdsChange = new EventEmitter<string[]>();

    @Input() public companyFilters: IApiCompanyFilter[] = [
        {
            type: IApiCompanyFilterType.HasSageKey,
            value: 'true'
        }
    ];

    @Output() public filterChange = new EventEmitter<string | null>();
    @Output() public enterPressed = new EventEmitter<void>();

    /** Resolved company names kept in sync with selectedCompanyIds */
    private _selectedCompanyNames: string[] = [];

    constructor(private companyService: CompanyService) { }

    public onOperatorChange(newVal: '$in' | '$notIn'): void {
        this.operator = newVal;
        this.operatorChange.emit(newVal);
        this._emitFilter();
    }

    /** Called by (selectionChanged) — receives IDs, then fetches names */
    public onSelectionChanged(ids: string[]): void {
        this.selectedCompanyIds = ids ?? [];
        this.selectedCompanyIdsChange.emit(this.selectedCompanyIds);

        if (!this.selectedCompanyIds.length) {
            this._selectedCompanyNames = [];
            this._emitFilter();
            return;
        }

        const filters: IApiCompanyFilter[] = [
            { type: IApiCompanyFilterType.Ids, value: JSON.stringify(this.selectedCompanyIds) },
            { type: IApiCompanyFilterType.ViewOnlyName, value: 'true' }
        ];
        if (this.companyFilters?.length) {
            filters.push(...this.companyFilters);
        }

        this.companyService.get(filters).pipe(unwrapConnection()).subscribe((companies: IApiCompany[]) => {
            this._selectedCompanyNames = companies.map(c => c.name);
            this._emitFilter();
        });
    }

    public onEnterPressed(): void {
        this.enterPressed.emit();
    }

    /** Emits filter using company NAMES:
     *  {"$in":{"customer.contacts.default.companyName":["ACME Corp"]}}
     *  {"$notIn":{"customer.contacts.default.companyName":["ACME Corp"]}}
     */
    private _emitFilter(): void {
        if (this._selectedCompanyNames?.length > 0) {
            const filterValue = JSON.stringify({
                [this.operator]: { [this.companyKey]: this._selectedCompanyNames }
            });
            this.filterChange.emit(filterValue);
        } else {
            this.filterChange.emit(null);
        }
    }
}
